import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { DIVISIONS_FEATURE_KEY } from './keys';
import { divisionsReducer } from './reducers/divisions.reducer';
import { DivisionsEffects } from './effects/divisions.effects';
import { DivisionsDivisionBridge } from './bridges/divisions_division.bridge';

export function provideDivisionsStore(): EnvironmentProviders[] {
    return [provideState(DIVISIONS_FEATURE_KEY, divisionsReducer), provideEffects(DivisionsEffects, DivisionsDivisionBridge)];
}
